<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-light fixed-top py-3" id="mainNav">
  <div class="container">
    <a class="navbar-brand js-scroll-trigger" href="#page-top">Cheer Develop Limited</a>
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto my-2 my-lg-0">
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#about">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#services">Services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#portfolio">Portfolio</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#contact">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!-- Masthead -->
<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center justify-content-center text-center">
      <div class="col-lg-10 align-self-end">
        <h1 class="text-uppercase text-white font-weight-bold">Your IT and digital publishing partner</h1>
        <hr class="divider my-4">
      </div>
      <div class="col-lg-8 align-self-baseline">
        <p class="text-white-75 font-weight-light mb-5">Bevis Publishing and Design House is a business fully owned by Cheer Develop Limited. Since March 2016, we started to provide IT and digital publishing solutions to local business.</p>
        <p class="text-white-75 font-weight-light mb-5">With our services, local businesses, especially education institutes, are now free from technical issues on IT, publishing and digital publishing production and free to creative via multi-sections.</p>
        <a class="btn btn-primary btn-xl js-scroll-trigger" href="#about">Find Out More</a>
      </div>
    </div>
  </div>
</header>

<!-- About Section -->
<section class="page-section bg-primary" id="about">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 text-center">
        <h2 class="text-white mt-0">We've got what you need!</h2>
        <hr class="divider light my-4">
        <p class="text-white-50 mb-4">We have many ready-made products for you. Just a call or an email, we can show you our products!</p>
        <a class="btn btn-light btn-xl js-scroll-trigger" href="#contact">Contact Us Now!</a>
      </div>
    </div>
  </div>
</section>


<!-- Services Section -->
<section class="page-section" id="services">
  <div class="container">
    <h2 class="text-center mt-0">At Your Service</h2>
    <hr class="divider my-4">
    <div class="row">
      <div class="col-lg-3 col-md-6 text-center">
        <div class="mt-5">
          <i class="fas fa-4x fa-gem text-primary mb-4"></i>
          <h3 class="h4 mb-2">Plenty Themes</h3>
          <p class="text-muted mb-0">Our themes are updated regularly to keep them it fresh!</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 text-center">
        <div class="mt-5">
          <i class="fas fa-4x fa-laptop-code text-primary mb-4"></i>
          <h3 class="h4 mb-2">Industry Know-how</h3>
          <p class="text-muted mb-0">We got partners who are running education institutes.</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 text-center">
        <div class="mt-5">
          <i class="fas fa-4x fa-globe text-primary mb-4"></i>
          <h3 class="h4 mb-2">Ready to Publish</h3>
          <p class="text-muted mb-0">You can use ready-made design to publish books or apps!</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 text-center">
        <div class="mt-5">
          <i class="fas fa-4x fa-heart text-primary mb-4"></i>
          <h3 class="h4 mb-2">Made with talent</h3>
          <p class="text-muted mb-0">We do talent-made for you as you wish!</p>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- Portfolio Section -->
<section id="portfolio">
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-lg-4 col-sm-6">
        <a class="portfolio-box" href="assets/img/portfolio/fullsize/books_Isee.jpg">
          <img class="img-fluid" src="assets/img/portfolio/thumbnails/Isee.png" alt="">
          <div class="portfolio-box-caption">
            <div class="project-category text-white-50">
              Kid Book
            </div>
            <div class="project-name">
              I See
            </div>
          </div>
        </a>
      </div>
      <div class="col-lg-4 col-sm-6">
        <a class="portfolio-box" href="assets/img/portfolio/fullsize/books_CatJumps.jpg">
          <img class="img-fluid" src="assets/img/portfolio/thumbnails/CatJumps.png" alt="">
          <div class="portfolio-box-caption">
            <div class="project-category text-white-50">
              Kid Book
            </div>
            <div class="project-name">
              Cat Jumps
            </div>
          </div>
        </a>
      </div>
      <div class="col-lg-4 col-sm-6">
        <a class="portfolio-box" href="assets/img/portfolio/fullsize/books_Butterfly.jpg">
          <img class="img-fluid" src="assets/img/portfolio/thumbnails/Butterfly.png" alt="">
          <div class="portfolio-box-caption">
            <div class="project-category text-white-50">
              Kid Book
            </div>
            <div class="project-name">
              Butterfly
            </div>
          </div>
        </a>
      </div>
      <div class="col-lg-4 col-sm-6">
        <a class="portfolio-box" href="assets/img/portfolio/fullsize/books_PlayPlayPlay.jpg">
          <img class="img-fluid" src="assets/img/portfolio/thumbnails/PlayPlayPlay.png" alt="">
          <div class="portfolio-box-caption">
            <div class="project-category text-white-50">
              Kid Book
            </div>
            <div class="project-name">
              Play Play Play
            </div>
          </div>
        </a>
      </div>
      <div class="col-lg-4 col-sm-6">
        <a class="portfolio-box" href="assets/img/portfolio/fullsize/books_RainRain.jpg">
          <img class="img-fluid" src="assets/img/portfolio/thumbnails/RainRain.png" alt="">
          <div class="portfolio-box-caption">
            <div class="project-category text-white-50">
              Kid Book
            </div>
            <div class="project-name">
              Rain Rain
            </div>
          </div>
        </a>
      </div>
      <div class="col-lg-4 col-sm-6">
        <a class="portfolio-box" href="assets/img/portfolio/fullsize/books_YumYum.jpg">
          <img class="img-fluid" src="assets/img/portfolio/thumbnails/YumYum.png" alt="">
          <div class="portfolio-box-caption p-3">
            <div class="project-category text-white-50">
              Kid Book
            </div>
            <div class="project-name">
              Yum Yum
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- Contact Section -->
<section class="page-section bg-dark text-white" id="contact">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 text-center">
        <h2 class="mt-0">Let's Get In Touch!</h2>
        <hr class="divider my-4">
        <p class="text-muted mb-5">Ready to start your next project with us? Give us a call or send us an email and we will get back to you as soon as possible!</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 ml-auto text-center mb-5 mb-lg-0">
        <i class="fas fa-comment fa-3x mb-3 text-muted"></i>
        <div><a href="https://wa.me/85268226612">Whatsapp</a></div>
      </div>
      <div class="col-lg-4 mr-auto text-center">
        <i class="fas fa-envelope fa-3x mb-3 text-muted"></i>
        <!-- Make sure to change the email address in anchor text AND the link below! -->
        <a class="d-block" href="mailto:info@bevispublishing.hk">info@bevispublishing.hk</a>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="bg-light py-5">
  <div class="container">
    <div class="small text-center text-muted">Copyright &copy; 2016 - Cheer Develop Limited (Bevis Publishing and Design House) </div>
  </div>
</footer>
<router-outlet></router-outlet>
